import Disclaimer from 'components/Disclaimer'

const LoanInformation = ({ className = '' }: { className?: string }) => (
  <div className={`w-full mb-8 ${className}`}>
    <Disclaimer
      description='Pedir tu adelanto te ayuda a construir un historial crediticio: ¡pagá la
      cuota a tiempo!'
      className='mb-2'
      leftFlapVariant='yellow'
      borderVariant='gray'
      textClassName='py-3'
    />
    <Disclaimer
      description='Podés pedir más de 1 adelanto si tenés crédito disponible: ¡Usalo cuando
      quieras!'
      leftFlapVariant='blue'
      borderVariant='gray'
      textClassName='py-3'
    />
  </div>
)

export default LoanInformation
